import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { detect } from 'detect-browser';
import { NavigationService } from '../services/navigation.service';

@Injectable()
export class IEGuard {
  constructor(private navigationService: NavigationService) {}

  public canActivate(state: RouterStateSnapshot) {
    const browser = detect();
    // Przepuszczamy dla routki, do której przenosimy, gdy wykryjemy IE (inaczej wpadamy w nieskończoną pętlę)
    if (state.url.includes('internet-explorer')) {
      return true;
    } else if (browser.name === 'ie') {
      this.navigationService.navigateToInternetExplorer();
      return false;
    } else {
      return true;
    }
  }
}
